import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackRemoveFromWishListItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackRemoveFromWishListParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackRemoveFromWishListItem> {}

const trackRemoveFromWishList = (
    parameters: TrackRemoveFromWishListParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.eventList({ action: "remove_from_wishlist", ...parameters }, options);
};

export default trackRemoveFromWishList;
